import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { WagoApiClient } from '@shared/service/wago-api.client';
import { ModelConversionService } from '@shared/convert/model-conversion.service';
import { LabelTextureDataVO, LabelTextureRequestVO } from '@3d-scene/processor/texture.vo';
import { ProjectModel } from '../../../model/project.model';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LabelTextureDataService {

  constructor(
    private modelConversionService: ModelConversionService,
    private wagoApiClient: WagoApiClient,
    private projectModel: ProjectModel
  ) {}

  public generateLabelTextures(labelTextureRequests: LabelTextureRequestVO[]): Observable<LabelTextureDataVO[]> {
    const projectId = this.projectModel.currentProject.id;
    const params: HttpParams = new HttpParams().set('projectId', isNaN(projectId) ? '-1' : projectId.toString());

    return this.wagoApiClient
      .post('label-texture/generate', labelTextureRequests, { params }, { isErrorHandlingRequired: false })
      .pipe(map((labelTextureData: any) => this.modelConversionService.convertLabelTextureDataVOs(labelTextureData)));
  }
}
